export enum McGrossOpb {
  QT_CRS = 500,
  MULT_100 = 501,
  BF_DIV_100 = 505,
}
